export default __webpack_public_path__ + "static/media/commercial.04e1da9e.webp";